<div>
  <span i18n>
    Processed
    <span class="tw:font-bold">{{ succeededTaskCount + failedTaskCount }}</span>
    out of <span class="tw:font-bold">{{ totalTaskCount }}</span> items.</span
  >
  @if (isProcessed) {
    <span class="tw:text-green-600 tw:ml-2" data-testId="success-text" i18n>
      <b>{{ succeededTaskCount }}</b> successful,
    </span>
  }
  @if (isProcessed) {
    <span class="tw:text-red-600 tw:ml-2" data-testId="error-text" i18n>
      <b>{{ failedTaskCount }}</b>
      errors
    </span>
  }
  @if (!isProcessed) {
    <span class="tw:ml-2" i18n>Please be patient, this could take a few minutes...</span>
  }
</div>
